import $ from 'jquery';
import Filter from './Filter';
import GoogleMapsLoader from 'google-maps';

export default class MapFilter extends Filter {

  constructor($element, options) {
    super($element, options);
    if ($element.length === 0) return false;

    if ($element.length < 1) return;

    this.value = {
      lat: null,
      lng: null,
      geo: 'Unknown'
    }

    this.filterType = "MapFilter";
    this.emptyValue = "";
    this.markersById = {};

    this.isActive = true;
    this.isLoaded = false;
    GoogleMapsLoader.LIBRARIES = ['places'];
    GoogleMapsLoader.KEY = 'AIzaSyA3AUzRF7_Og32sCYINzRlvqiMhlXWlu-M';
    GoogleMapsLoader.load((google) => {
        this.onMapsLoaded(google);
    });

    $(window).on('resize', () => {
      this.resize();
    });
  }

  onMapsLoaded(google) {
    // let geoFilter = window.WJP.query.getFilters('geo')[0];
    //
    // let center = (geoFilter && geoFilter.getValue(true)) ? {
    //   lat: geoFilter.getValue(true).lat,
    //   lng: geoFilter.getValue(true).lng
    // } : {
    //   lat: 51.5,
    //   lng: 4.5
    // };

    let center = {
      lat: 51.5,
      lng: 4.5
    }

    this.mapInstance = new google.maps.Map(this.$element.get(0), {
      center: center,
      zoom: 8
    });

    this.geocoder = new google.maps.Geocoder();

    this.mapInstance.addListener('dragend', function() {
       this.centerChangedTimeout && clearTimeout(this.centerChangedTimeout);
       this.centerChangedTimeout = setTimeout(this.centerChanged, 500);
    });

    this.infowindow = new google.maps.InfoWindow();
    this.markerClusterer = new MarkerClusterer(this.mapInstance, null, {imagePath: '/wp-content/plugins/wp-jobs-pro/assets/components/markerclustererplus/images/m'});

    this.update();
    this.isLoaded = true;

    $.messages.send({
      type: 'FILTER/MAP/LOADED',
      sender: this
    });

  }

  resize() {
    if (this.isLoaded) {
      google.maps.event.trigger(this.mapInstance, 'resize');
    }
  }

  isMap() {
    return this.isActive || false;
  }

  update(fitToMarkers = true) {
    this.fetchMarkers((data) => {
      this.initMarkers(data.jobs, fitToMarkers);

      // if(updateBounds && data.jobs.length)
        // this.mapInstance.fitBounds(data.bounds);
    });
  }

  // Pan & Zoom map to show all markers
  fitToMarkers(markers) {
      let bounds = new google.maps.LatLngBounds();

      // Create bounds from markers
      for( let index in markers ) {
          let latlng = markers[index].getPosition();
          bounds.extend(latlng);
      }

      // Don't zoom in too far on only one marker
      if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
         let extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.01, bounds.getNorthEast().lng() + 0.01);
         let extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.01, bounds.getNorthEast().lng() - 0.01);
         bounds.extend(extendPoint1);
         bounds.extend(extendPoint2);
      }

      this.mapInstance.fitBounds(bounds);
  }

  centerChanged() {
    let center = this.mapInstance.getCenter();
    this.setValue({
      lat: center.lat(),
      lng: center.lng()
    });
    this.markAsActive();
    this.update(false);
  }

  fetchMarkers(callback) {
    // window.WJP.query.updateIndex();
    $.get('/wjp/map.json?' + window.WJP.query.createRequest(), function(data) {
      console.log('map data', data);
      callback(data);
    });
  }

  initMarkers(jobs, fitToMarkers) {
    let newMarkers = [];
    let newMarkerIds = {};

    // Add new markers
    for (let i = 0; i < jobs.length; i++) {
      let job = jobs[i];

      newMarkerIds[job.ID] = job;

      if(!this.markersById[job.ID]) {
        let marker = new google.maps.Marker({
          position: {lat: job.lat, lng: job.lng}
        });

        marker.__id = job.ID;

        (function(marker, job, _this) {
          google.maps.event.addListener(marker, 'click', function() {
            _this.infowindow.setContent('<a href="/job/' + job.slug + '">' + job.title + '</a>');
            _this.infowindow.open(_this.mapInstance, this);
          });
        })(marker, job, this);

        newMarkers.push(marker);

        this.markersById[job.ID] = marker;
      }
    }

    let currentMarkers = this.markerClusterer.getMarkers().slice();
    // Delete old markers
    for (let i = 0; i < currentMarkers.length; i++) {
      let marker = currentMarkers[i];
      if(!newMarkerIds[marker.__id]) {
        this.markerClusterer.removeMarker(marker);
        delete this.markersById[marker.__id];
      }
    }

    this.markerClusterer.addMarkers(newMarkers);

    if(fitToMarkers && this.markerClusterer.getMarkers().length) {
      this.fitToMarkers(this.markerClusterer.getMarkers());
    }
  }

  getKey() {
    return 'geo';
  }

  getValue(asObject = false) {

    // Return the value
    if(this.value && this.value.lat && this.value.lng) {
      // But first synchronize the other filters
      // this.syncFilters();
      return asObject ? this.value : this.value.geo + '&lat=' + this.value.lat + '&lng=' + this.value.lng + '&distance=100';
    }

    return null;
  }

  setValue(value) {
      if (typeof value == "string") {
        value = URI.parseQuery('geo=' + value);
      }

      this.value = value;

      if (this.isLoaded) {
        // Check if it's necessery to change the map center
        let currentCenter = this.mapInstance.getCenter();
        let newCenter = new google.maps.LatLng({ lat: parseFloat(value.lat), lng: parseFloat(value.lng) });

        if (!newCenter.equals(currentCenter)) {
          this.mapInstance.setCenter(newCenter);
          this.center = newCenter;
        }

        this.resize();

        // Check if the geo name is given, otherwise geocode it
        if(!value.geo) {
          this.geocoder.geocode({ 'latLng': this.mapInstance.getCenter() }, function(results, status) {
            if( status === "OK" ) {
              this.value.geo = results[0].formatted_address;
            }
          });
        }
    } else {
      // $.messages.on('FILTER/MAP/LOADED', (action) => {
      //     console.log(value);
      //     this.setValue(value);
      // });
    }
  }

}



/** WEBPACK FOOTER **
 ** ../assets/js/filters/MapFilter.js
 **/